import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const options = [
    'Make Admin',
    'Demote to User',
    'Block',

];

const ITEM_HEIGHT = 30;

export default function DotMenuBar() {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const [email, setEmail] = React.useState('');
    const handleAdminClick = e => {
        const user = { email };
        fetch("https://pro-player-livid.vercel.app/users", {
            method: 'PUT',
            headers: {

                'content-type': 'application/json'
            },
            body: JSON.stringify(user)
        })
            .then(res => res.json())
            .then(data => {

                console.log(data);

            })
        e.preventDefault()
    }


    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    let mode;
    mode = localStorage.getItem("theme")
    const text = mode === "light" ? "black" : "darkLight";
    const card = mode === "light" ? "moreLight" : "moreDark";
    const bg = mode === "light" ? "lightest" : "darkish";

    return (
        <div >
            <IconButton
                aria-label="more"

                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
                style={{ padding: "4px" }}
                id={text}
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="long-menu"
                MenuListProps={{
                    'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: '20ch',
                    },
                }}
            >
                {options.map((option) => (
                    // <MenuItem key={option} onClick={handleClose}>
                    <MenuItem key={option} onClick={handleAdminClick}>

                        {option}

                    </MenuItem>
                ))}
            </Menu>
        </div >
    );
}